import Stars from 'comps/Stars';
import dayjs from 'dayjs';
import IconUser from 'icons/icon-user.svg';

export default function EvaluationCard({ item }) {
  function getQuickReasons(quickReasonsStr) {
    var quickReasonsArr = [];
    try {
      quickReasonsArr = JSON.parse(quickReasonsStr);
    } catch (e) {
      console.log(e);
    }
    return Array.isArray(quickReasonsArr) ? quickReasonsArr : [];
  }

  return (
    <>
      <div className="evaluation-list">
        <div className="evaluation-card">
          <div className="uh">
            <IconUser />
          </div>
          <div className="card-name" title="item.organizationName">
            {item.organizationName}
          </div>
          <div className="card-content-wrap">
            <div className="card-content-star-wrap">
              <Stars score={item.totalScore} custom={{ starSize: 14, starGap: 7 }} />
            </div>
            <p className="evaluation-card-desc">{item.comment || '此用户未填写评价内容'}</p>
            {getQuickReasons(item.quickReasons).length ? (
              <div className="evaluation-quick-reasons-wrap">
                {getQuickReasons(item.quickReasons).map((val, idx) => {
                  return (
                    <div key={idx} className="evaluation-quick-reason">
                      {val.name}
                    </div>
                  );
                })}
              </div>
            ) : null}
            <div className="evaluation-card-date">{dayjs(item?.editDate).format('YYYY-MM-DD')}</div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
        .evaluation-list {
          line-height: 1;
        }
    
        .evaluation-card {
          border-bottom: 1px solid #f1f1f1;
          padding: 38px 0 25px 56px;
          position: relative;
          display: flex;
        }
        .card-name {
          flex: 0 0 110px;
          padding-right: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .vue-star-item {
          width: 15px;
          margin-right: 7px;
        }
        .evaluation-card-desc {
          margin-top: 6px;
        }
        .evaluation-card-date {
          font-size: 14px;
          color: #999999;
          margin-top: 20px;
        }
        .evaluation-quick-reason {
          line-height: 22px;
          margin-top: 6px;
        }
        .uh {
          position: absolute;
          left: 0;
          top: 25px;
          height: 40px;
          width: 40px;
          border-radius: 50%;
          background: #f4f6f7;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
        }
        .uh :global(svg) {
          width: 24px;
          height: 22px;
        }
        .uh :global(svg) :global(path) {
          fill: #bbbebf;
        }
        `}
      </style>
    </>
  );
}
